import { render, staticRenderFns } from "./CommunityFlaggedComments.vue?vue&type=template&id=832cac10&scoped=true&"
import script from "./CommunityFlaggedComments.vue?vue&type=script&lang=ts&"
export * from "./CommunityFlaggedComments.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityFlaggedComments.vue?vue&type=style&index=0&id=832cac10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832cac10",
  null
  
)

export default component.exports